// extracted by css-extract-rspack-plugin
export default {"description":"description--Do6gp8OKxwYiiHST"};